<template>
  <div class="userInfo publick">
    <div class="userInfoTitle fl">
      <div class="img">
        <img :src="info.avatar" width="100" height="100" alt="">
        <input type="file" class="upload" multiple="multiple" @change="addImg" id="upload-ele"
               accept="image/png,image/jpeg,image/gif,image/jpg"/>
      </div>
      <div class="name">{{info.username}}</div>
      <ul>
        <router-link to="/userInfo/userInformation" class="one" tag="li">
          <img src="./U-img/1.png" class="img1" alt="">
          <img src="./U-img/2.png" class="img2" alt="">
          个人信息
        </router-link>
        <router-link to="/userInfo/userSetup" class="two" tag="li">
          <img src="./U-img/3.png" class="img1" alt="">
          <img src="./U-img/4.png" class="img2" alt="">
          安全设置
        </router-link>
        <router-link to="/userInfo/AskForLeave" tag="li">
          <img src="./U-img/15.png" class="img1" alt="">
          <img src="./U-img/16.png" class="img2" alt="">
          教师事项
        </router-link>
        <router-link to="/userInfo/userTraining" tag="li">
          <img src="./U-img/5.png" class="img1" alt="">
          <img src="./U-img/6.png" class="img2" alt="">
          培训记录
        </router-link>
        <router-link to="/userInfo/userLive" tag="li">
          <img src="./U-img/7.png" class="img1" alt="">
          <img src="./U-img/8.png" class="img2" alt="">
          直播预约
        </router-link>
        <router-link to="/userInfo/userCourse" tag="li">
          <img src="./U-img/9.png" class="img1" alt="">
          <img src="./U-img/10.png" class="img2" alt="">
          线上课程
        </router-link>
        <router-link to="/userInfo/userIntegral" tag="li">
          <img src="./U-img/11.png" class="img1" alt="">
          <img src="./U-img/12.png" class="img2" alt="">
          我的积分
        </router-link>
        <router-link to="/userInfo/userFocus" tag="li">
          <img src="./U-img/13.png" class="img1" alt="">
          <img src="./U-img/14.png" class="img2" alt="">
          我的关注
        </router-link>
      </ul>
    </div>
    <div class="userView fl">
      <router-view></router-view>
    </div>
    <layerRight></layerRight>
  </div>
</template>

<script>
  import layerRight from '@/components/layerRight/layerRight'

  export default {
    components: {
      layerRight
    },
    data () {
      return {
        info: {},
        srcS: ''
      }
    },
    created () {
      this.$store.state.headindex = 99
      this.getUserinfo()
    },
    methods: {
      getUserinfo () {
        this.$http.post('/apipx/Personal/info', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      },
      addImg () {
        let file = document.getElementById('upload-ele').files[0]
        // console.log(file)
        let config = {
          headers: {'Content-Type': 'multipart/form-data'}
        }
        let formData = new FormData()
        formData.append('type', 'image')
        formData.append('group', 'user')
        formData.append('method', 'post')
        formData.append('file', file)
        formData.append('token', JSON.parse(localStorage.getItem('login')).token)
        const that = this
        this.$http.post('/apipx/Tool/upload', formData, config).then(function (res) {
          if (res.code === 0) {
            that.srcS = res.data.src[0]
            console.log(that.srcS)

            that.$confirm('是否替换头像?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.$http.post('/apipx/Personal/setinfo', {
                sex: that.info.sex,
                username: that.info.username,
                avatar: that.srcS,
                signature: that.info.signature,
                token: JSON.parse(localStorage.getItem('login')).token
              }).then(res => {
                if (res.code === 0) {
                  that.getUserinfo()
                  let login = JSON.parse(localStorage.getItem('login'))
                  login.avatar = that.srcS
                  localStorage.setItem('login', JSON.stringify(login))
                  location.reload()
                }
              })
            })
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .userInfo {
    .userInfoTitle {
      width: 270px;
      height: 790px;
      border-radius: 30px;
      overflow: hidden;
      box-shadow: 0px 0px 40px #e2e0e0;
      margin: 100px 0;

      .img {
        width: 100px;
        height: 100px;
        box-shadow: 0px 0px 20px #e2e0e0;
        border-radius: 50%;
        margin: 25px auto;
        overflow: hidden;
        position: relative;

        input {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 9;
          opacity: 0;
        }
      }

      .name {
        width: 270px;
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        text-align: center;
      }

      ul {
        li {
          width: 100px;
          height: 50px;
          border-radius: 25px;
          line-height: 50px;
          margin: 35px auto 0;
          position: relative;
          padding: 0 0 0 80px;
          cursor: pointer;

          img {
            position: absolute;
            left: 40px;
            top: 10px;
            width: 30px;
            height: 30px;
          }

          .img2 {
            display: none;
          }

          &.choice {
            background-color: #fff2f2;
            color: #ff827b;

            .img1 {
              display: none;
            }

            .img2 {
              display: block;
            }
          }

          &:hover {
            background-color: #fff2f2;
            color: #ff827b;

            .img1 {
              display: none;
            }

            .img2 {
              display: block;
            }
          }
        }
      }
    }

    .userView {
      margin: 100px 0 100px 40px;
      width: 890px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/userInfo.vue